/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { simulatedTransaction } from "../simulated-transaction"

const CreateNfpmPoolAbi = [
  {
    inputs: [
      { internalType: "address", name: "token0", type: "address" },
      { internalType: "address", name: "token1", type: "address" },
      { internalType: "uint24", name: "fee", type: "uint24" },
      { internalType: "uint160", name: "sqrtPriceX96", type: "uint160" },
    ],
    name: "createAndInitializePoolIfNecessary",
    outputs: [{ internalType: "address", name: "pool", type: "address" }],
    stateMutability: "payable",
    type: "function",
  },
] as const

type CreateNfpmPoolProps = {
  account: Address
  chainId: number
  config: Config
  token0Address: Address
  token1Address: Address
  fee: number
  sqrtPriceX96: bigint
  nfpManagerAddress: Address
}

export const createNfpmPool = async ({
  account,
  chainId,
  config,
  token0Address,
  token1Address,
  fee,
  sqrtPriceX96,
  nfpManagerAddress,
}: CreateNfpmPoolProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: CreateNfpmPoolAbi as Abi,
        account,
        address: nfpManagerAddress,
        args: [token0Address, token1Address, fee, sqrtPriceX96],
        chainId,
        functionName: "createAndInitializePoolIfNecessary",
      },
      // gas: BigInt(9600000),
    })
    return result
  } catch (error: any) {
    console.error("createNfpmPool", error)
    return { success: false, error: error.message, code: error.code }
  }
}
